import { Category } from '@/types/Category';
import { FC } from 'react';

import styles from './b2b-category.module.scss';
import { replaceOrAddLocale, useLocale } from '@/helpers/LangHelper';
import classNames from 'classnames';

interface Props {
    categories: Category[];
    theme?: 'dark' | 'light';
    className?: string;
}

export const B2BCategory: FC<Props> = (props) => {
    const { categories = [], theme = 'dark' } = props;

    const { locale } = useLocale();

    return (
        <div className={classNames(styles.container, styles[theme])}>
            {categories.map((cate) => {
                const url = replaceOrAddLocale(cate.categoryUrl ?? '', locale);

                return (
                    <a key={cate.id} className={styles.item} href={url}>
                        {cate.name}
                    </a>
                );
            })}
        </div>
    );
};
